import { useTranslation } from 'react-i18next';

import { useExamEvent, useNewExam } from '../../providers';
import { getQuestionOrder } from '../../utils';

export default function ExamReviewHeader() {
  const { t } = useTranslation();
  const { questions, currentExamOrder } = useNewExam();
  const { examEvent } = useExamEvent();

  const { minQuestionOrder, maxQuestionOrder } = getQuestionOrder(questions);
  const shouldShowSectionText = examEvent.metadata.events.length > 1;
  const currentExamSection =
    shouldShowSectionText && currentExamOrder
      ? `${t('examReviewHeader.section')} ${currentExamOrder}`
      : undefined;
  const header = [t('examReviewHeader.answerSheet'), currentExamSection].filter(Boolean).join(' ');

  return (
    <div className='flex flex-none flex-col gap-3 text-center'>
      <h3 className='font-semibold'>
        {header}
        {` ${t('question.item', {
          number: minQuestionOrder,
        })} - ${maxQuestionOrder}`}
      </h3>
      <div className='text-body1'>{t('examReviewHeader.description')}</div>
    </div>
  );
}
